import React from 'react';
import { Button } from '../components/ui/Button';
import { WindIcon, ActivityIcon, UsersIcon, SunIcon, MoonIcon, CoffeeIcon, CheckIcon, ArrowRightIcon, MapPinIcon, CalendarIcon, SparklesIcon } from 'lucide-react';
export function SoulFlow() {
  const scrollToForm = () => {
    const element = document.getElementById('registration-form');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="font-sans text-[#333333] bg-[#F5F2EA]" data-id="element-2920">
      {/* 1. HERO SECTION */}
      <section className="relative min-h-screen flex flex-col items-center justify-center bg-[#2C3E2E] text-[#F5F2EA] px-4 py-20 overflow-hidden" data-id="element-2921">
        <div className="absolute inset-0 opacity-10 pointer-events-none" data-id="element-2922">
          {/* Subtle texture or noise could go here, using CSS radial gradient for now */}
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white/20 to-transparent" data-id="element-2923" />
        </div>

        <div className="relative z-10 flex flex-col items-center text-center max-w-4xl mx-auto space-y-8 animate-fade-in-up" data-id="element-2924">
          {/* Logo Mark */}
          <div className="w-24 h-24 rounded-full border border-[#F5F2EA]/30 flex items-center justify-center mb-6" data-id="element-2925">
            <span className="font-serif text-3xl italic" data-id="element-2926">SF</span>
          </div>

          <h1 className="font-serif text-5xl md:text-7xl lg:text-8xl tracking-tight leading-none" data-id="element-2927">
            SOUL FLOW
          </h1>

          <p className="text-lg md:text-xl font-light tracking-wide opacity-90 max-w-lg" data-id="element-2928">
            A luxury yoga and wellness escape curated for intentional living
          </p>

          <div className="flex flex-col items-center space-y-2 py-6 border-t border-b border-[#F5F2EA]/20 w-full max-w-md" data-id="element-2929">
            <div className="flex items-center space-x-2 text-sm md:text-base tracking-widest uppercase opacity-80" data-id="element-2930">
              <CalendarIcon className="w-4 h-4" data-id="element-2931" />
              <span data-id="element-2932">April 10–13, 2026</span>
            </div>
            <div className="flex items-center space-x-2 text-sm md:text-base tracking-widest uppercase opacity-80" data-id="element-2933">
              <CalendarIcon className="w-4 h-4" data-id="element-2934" />
              <span data-id="element-2935">April 17–20, 2026</span>
            </div>
            <div className="flex items-center space-x-2 text-sm md:text-base tracking-widest uppercase opacity-80" data-id="element-2936">
              <CalendarIcon className="w-4 h-4" data-id="element-2937" />
              <span data-id="element-2938">April 24–27, 2026</span>
            </div>
          </div>

          <div className="inline-flex items-center px-3 py-1 border border-[#F5F2EA]/40 rounded-full text-xs tracking-[0.2em] uppercase" data-id="element-2939">
            Invitation Only
          </div>

          <div className="flex flex-col sm:flex-row gap-6 mt-8" data-id="element-2940">
            <button onClick={scrollToForm} className="px-8 py-4 bg-[#F5F2EA] text-[#2C3E2E] font-medium tracking-wide hover:bg-[#E0E0E0] transition-colors duration-300 min-w-[200px]" data-id="element-2941">
              PRE-REGISTER
            </button>
            <button onClick={() => document.getElementById('intro')?.scrollIntoView({
            behavior: 'smooth'
          })} className="px-8 py-4 bg-transparent border border-[#F5F2EA]/30 text-[#F5F2EA] font-medium tracking-wide hover:bg-[#F5F2EA]/10 transition-colors duration-300 min-w-[200px]" data-id="element-2942">
              EXPLORE THE EXPERIENCE
            </button>
          </div>
        </div>
      </section>

      {/* 2. WHAT IS SOUL FLOW */}
      <section id="intro" className="py-24 px-4 md:px-12 bg-[#F5F2EA]" data-id="element-2943">
        <div className="max-w-6xl mx-auto" data-id="element-2944">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-24" data-id="element-2945">
            <div className="flex flex-col space-y-4" data-id="element-2946">
              <span className="text-xs font-bold tracking-[0.2em] text-[#2C3E2E]/60 uppercase" data-id="element-2947">
                01
              </span>
              <h3 className="font-serif text-3xl text-[#2C3E2E]" data-id="element-2948">Reset</h3>
              <p className="text-[#333333]/80 leading-relaxed font-light" data-id="element-2949">
                Disconnect from the noise. Realign your nervous system through
                breath, silence, and grounding practices designed to strip away
                the unnecessary.
              </p>
            </div>
            <div className="flex flex-col space-y-4" data-id="element-2950">
              <span className="text-xs font-bold tracking-[0.2em] text-[#2C3E2E]/60 uppercase" data-id="element-2951">
                02
              </span>
              <h3 className="font-serif text-3xl text-[#2C3E2E]" data-id="element-2952">Rebuild</h3>
              <p className="text-[#333333]/80 leading-relaxed font-light" data-id="element-2953">
                Cultivate resilience. Engage in strength, mobility, and
                controlled intensity to forge a body and mind capable of
                enduring grace.
              </p>
            </div>
            <div className="flex flex-col space-y-4" data-id="element-2954">
              <span className="text-xs font-bold tracking-[0.2em] text-[#2C3E2E]/60 uppercase" data-id="element-2955">
                03
              </span>
              <h3 className="font-serif text-3xl text-[#2C3E2E]" data-id="element-2956">Reconnect</h3>
              <p className="text-[#333333]/80 leading-relaxed font-light" data-id="element-2957">
                Find your tribe. Experience the power of shared intention and
                community in a space curated for depth, presence, and authentic
                connection.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 3. THE FLOW (ITINERARY) */}
      <section className="py-24 px-4 md:px-12 bg-[#9CAF9C]/20" data-id="element-2958">
        <div className="max-w-4xl mx-auto" data-id="element-2959">
          <div className="text-center mb-16" data-id="element-2960">
            <h2 className="font-serif text-4xl md:text-5xl text-[#2C3E2E] mb-4" data-id="element-2961">
              The Flow
            </h2>
            <p className="text-[#2C3E2E]/70 italic font-serif" data-id="element-2962">
              A curated rhythm for your days
            </p>
          </div>

          <div className="space-y-12 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-[#2C3E2E]/10 before:hidden md:before:block" data-id="element-2963">
            {/* Day 1 */}
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-2964">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border border-[#2C3E2E]/20 bg-[#F5F2EA] shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-2965">
                <span className="text-xs font-serif" data-id="element-2966">I</span>
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-6 bg-white/50 backdrop-blur-sm rounded-sm border border-[#2C3E2E]/5" data-id="element-2967">
                <div className="flex items-center justify-between mb-2" data-id="element-2968">
                  <h3 className="font-serif text-xl text-[#2C3E2E]" data-id="element-2969">
                    Arrival & Grounding
                  </h3>
                  <span className="text-xs tracking-widest uppercase opacity-60" data-id="element-2970">
                    Day One
                  </span>
                </div>
                <ul className="space-y-2 text-sm text-[#333333]/80 font-light" data-id="element-2971">
                  <li className="flex items-center" data-id="element-2972">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-2973"></span>
                    Private transfers
                  </li>
                  <li className="flex items-center" data-id="element-2974">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-2975"></span>
                    Intentional welcome
                  </li>
                  <li className="flex items-center" data-id="element-2976">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-2977"></span>
                    Orientation & opening ceremony
                  </li>
                </ul>
              </div>
            </div>

            {/* Day 2 */}
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-2978">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border border-[#2C3E2E]/20 bg-[#F5F2EA] shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-2979">
                <span className="text-xs font-serif" data-id="element-2980">II</span>
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-6 bg-white/50 backdrop-blur-sm rounded-sm border border-[#2C3E2E]/5" data-id="element-2981">
                <div className="flex items-center justify-between mb-2" data-id="element-2982">
                  <h3 className="font-serif text-xl text-[#2C3E2E]" data-id="element-2983">
                    Flow & Recharge
                  </h3>
                  <span className="text-xs tracking-widest uppercase opacity-60" data-id="element-2984">
                    Day Two
                  </span>
                </div>
                <ul className="space-y-2 text-sm text-[#333333]/80 font-light" data-id="element-2985">
                  <li className="flex items-center" data-id="element-2986">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-2987"></span>
                    Sunrise movement
                  </li>
                  <li className="flex items-center" data-id="element-2988">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-2989"></span>
                    Nourishing meals
                  </li>
                  <li className="flex items-center" data-id="element-2990">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-2991"></span>
                    Breakout sessions
                  </li>
                  <li className="flex items-center" data-id="element-2992">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-2993"></span>
                    Sunset yoga & meditation
                  </li>
                </ul>
              </div>
            </div>

            {/* Day 3 */}
            <div className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-2994">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border border-[#2C3E2E]/20 bg-[#F5F2EA] shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 z-10" data-id="element-2995">
                <span className="text-xs font-serif" data-id="element-2996">III</span>
              </div>
              <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-6 bg-white/50 backdrop-blur-sm rounded-sm border border-[#2C3E2E]/5" data-id="element-2997">
                <div className="flex items-center justify-between mb-2" data-id="element-2998">
                  <h3 className="font-serif text-xl text-[#2C3E2E]" data-id="element-2999">
                    Integrate & Release
                  </h3>
                  <span className="text-xs tracking-widest uppercase opacity-60" data-id="element-3000">
                    Day Three
                  </span>
                </div>
                <ul className="space-y-2 text-sm text-[#333333]/80 font-light" data-id="element-3001">
                  <li className="flex items-center" data-id="element-3002">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-3003"></span>
                    Morning practice
                  </li>
                  <li className="flex items-center" data-id="element-3004">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-3005"></span>
                    Reflection & community
                  </li>
                  <li className="flex items-center" data-id="element-3006">
                    <span className="w-1 h-1 bg-[#2C3E2E]/40 rounded-full mr-2" data-id="element-3007"></span>
                    Closing ritual
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4. WHAT'S INCLUDED */}
      <section className="py-24 px-4 md:px-12 bg-[#F5F2EA]" data-id="element-3008">
        <div className="max-w-5xl mx-auto" data-id="element-3009">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-3010">
            <div data-id="element-3011">
              <h2 className="font-serif text-4xl md:text-5xl text-[#2C3E2E] mb-8" data-id="element-3012">
                Inclusions
              </h2>
              <div className="space-y-6" data-id="element-3013">
                {[{
                icon: <SparklesIcon className="w-5 h-5" data-id="element-3014" />,
                text: '5-star all-inclusive accommodations'
              }, {
                icon: <MapPinIcon className="w-5 h-5" data-id="element-3015" />,
                text: 'Signature ground transportation'
              }, {
                icon: <ActivityIcon className="w-5 h-5" data-id="element-3016" />,
                text: 'Daily yoga, mobility & movement sessions'
              }, {
                icon: <WindIcon className="w-5 h-5" data-id="element-3017" />,
                text: 'Breathwork, meditation & wellness seminars'
              }, {
                icon: <UsersIcon className="w-5 h-5" data-id="element-3018" />,
                text: 'Curated community experience'
              }].map((item, idx) => <div key={idx} className="flex items-center space-x-4 group" data-id="element-3019">
                    <div className="w-10 h-10 rounded-full bg-[#2C3E2E]/5 flex items-center justify-center text-[#2C3E2E] group-hover:bg-[#2C3E2E] group-hover:text-[#F5F2EA] transition-colors duration-300" data-id="element-3020">
                      {item.icon}
                    </div>
                    <span className="text-lg font-light text-[#333333]" data-id="element-3021">
                      {item.text}
                    </span>
                  </div>)}
              </div>
              <p className="mt-8 text-sm text-[#333333]/50 italic border-l-2 border-[#2C3E2E]/20 pl-4" data-id="element-3022">
                Note: Flights are arranged independently for flexibility and
                ease.
              </p>
            </div>
            <div className="relative h-[500px] w-full bg-[#2C3E2E]/5 rounded-sm overflow-hidden" data-id="element-3023">
              {/* Placeholder for an abstract/calm image */}
              <div className="absolute inset-0 bg-[#8FA893]/30 mix-blend-multiply" data-id="element-3024" />
              <img src="https://images.unsplash.com/photo-1545205597-3d9d02c29597?q=80&w=2070&auto=format&fit=crop" alt="Calm wellness atmosphere" className="w-full h-full object-cover opacity-80 grayscale-[20%]" data-id="element-3025" />
            </div>
          </div>
        </div>
      </section>

      {/* 5. MORE THAN YOGA */}
      <section className="py-24 px-4 md:px-12 bg-[#2C3E2E] text-[#F5F2EA]" data-id="element-3026">
        <div className="max-w-6xl mx-auto" data-id="element-3027">
          <div className="text-center mb-16" data-id="element-3028">
            <h2 className="font-serif text-4xl md:text-5xl mb-4" data-id="element-3029">
              More Than Yoga
            </h2>
            <p className="text-[#F5F2EA]/70 font-light max-w-2xl mx-auto" data-id="element-3030">
              A holistic approach to well-being, integrating ancient wisdom with
              modern science.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#F5F2EA]/10 border border-[#F5F2EA]/10" data-id="element-3031">
            {[{
            title: 'Yoga & Flow',
            desc: 'Movement to align body and breath.'
          }, {
            title: 'Breathwork & Meditation',
            desc: 'Tools to master your nervous system.'
          }, {
            title: 'Strength & HIIT',
            desc: 'Build resilience through controlled intensity.'
          }, {
            title: 'Mobility & Recovery',
            desc: 'Restore range of motion and ease.'
          }, {
            title: 'Nutrition & Mindful Eating',
            desc: 'Fuel your body with intention.'
          }, {
            title: 'Community Rituals',
            desc: 'Connect deeply with like-minded souls.'
          }].map((tile, idx) => <div key={idx} className="bg-[#2C3E2E] p-8 md:p-12 hover:bg-[#2C3E2E]/80 transition-colors duration-300 group" data-id="element-3032">
                <h3 className="font-serif text-2xl mb-2 group-hover:text-[#8FA893] transition-colors" data-id="element-3033">
                  {tile.title}
                </h3>
                <p className="text-[#F5F2EA]/60 font-light text-sm" data-id="element-3034">
                  {tile.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 6. INVESTMENT */}
      <section className="py-24 px-4 md:px-12 bg-[#8FA893]/30" data-id="element-3035">
        <div className="max-w-5xl mx-auto" data-id="element-3036">
          <div className="text-center mb-16" data-id="element-3037">
            <h2 className="font-serif text-4xl md:text-5xl text-[#2C3E2E] mb-4" data-id="element-3038">
              Investment
            </h2>
            <p className="text-[#2C3E2E]/70 font-light" data-id="element-3039">
              Secure your place in the circle.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-3040">
            {/* Single Occupancy */}
            <div className="bg-[#F5F2EA] p-8 md:p-12 border border-[#2C3E2E]/5 flex flex-col items-center text-center hover:shadow-xl transition-shadow duration-500" data-id="element-3041">
              <h3 className="text-xs font-bold tracking-[0.2em] text-[#2C3E2E]/60 uppercase mb-4" data-id="element-3042">
                Private Sanctuary
              </h3>
              <h4 className="font-serif text-3xl text-[#2C3E2E] mb-2" data-id="element-3043">
                Single Occupancy
              </h4>
              <div className="text-4xl font-light text-[#2C3E2E] mb-8" data-id="element-3044">
                $2,199 <span className="text-base opacity-50" data-id="element-3045">USD</span>
              </div>
              <ul className="space-y-3 text-sm text-[#333333]/70 mb-8 w-full text-left pl-8 md:pl-12" data-id="element-3046">
                <li className="flex items-center" data-id="element-3047">
                  <CheckIcon className="w-4 h-4 mr-3 text-[#8FA893]" data-id="element-3048" /> Private
                  king suite
                </li>
                <li className="flex items-center" data-id="element-3049">
                  <CheckIcon className="w-4 h-4 mr-3 text-[#8FA893]" data-id="element-3050" /> En-suite
                  luxury bath
                </li>
                <li className="flex items-center" data-id="element-3051">
                  <CheckIcon className="w-4 h-4 mr-3 text-[#8FA893]" data-id="element-3052" /> Full
                  retreat access
                </li>
              </ul>
              <button onClick={scrollToForm} className="w-full py-4 border border-[#2C3E2E] text-[#2C3E2E] hover:bg-[#2C3E2E] hover:text-[#F5F2EA] transition-all duration-300 uppercase tracking-widest text-xs font-bold" data-id="element-3053">
                Select Single
              </button>
            </div>

            {/* Double Occupancy */}
            <div className="bg-[#F5F2EA] p-8 md:p-12 border border-[#2C3E2E]/5 flex flex-col items-center text-center hover:shadow-xl transition-shadow duration-500 relative overflow-hidden" data-id="element-3054">
              <div className="absolute top-0 right-0 bg-[#2C3E2E] text-[#F5F2EA] text-[10px] uppercase tracking-widest px-3 py-1" data-id="element-3055">
                Best Value
              </div>
              <h3 className="text-xs font-bold tracking-[0.2em] text-[#2C3E2E]/60 uppercase mb-4" data-id="element-3056">
                Shared Experience
              </h3>
              <h4 className="font-serif text-3xl text-[#2C3E2E] mb-2" data-id="element-3057">
                Double Occupancy
              </h4>
              <div className="text-4xl font-light text-[#2C3E2E] mb-8" data-id="element-3058">
                $1,599 <span className="text-base opacity-50" data-id="element-3059">USD</span>
              </div>
              <ul className="space-y-3 text-sm text-[#333333]/70 mb-8 w-full text-left pl-8 md:pl-12" data-id="element-3060">
                <li className="flex items-center" data-id="element-3061">
                  <CheckIcon className="w-4 h-4 mr-3 text-[#8FA893]" data-id="element-3062" /> Shared
                  luxury suite
                </li>
                <li className="flex items-center" data-id="element-3063">
                  <CheckIcon className="w-4 h-4 mr-3 text-[#8FA893]" data-id="element-3064" /> Two
                  queen beds
                </li>
                <li className="flex items-center" data-id="element-3065">
                  <CheckIcon className="w-4 h-4 mr-3 text-[#8FA893]" data-id="element-3066" /> Full
                  retreat access
                </li>
              </ul>
              <button onClick={scrollToForm} className="w-full py-4 bg-[#2C3E2E] text-[#F5F2EA] hover:bg-[#2C3E2E]/90 transition-all duration-300 uppercase tracking-widest text-xs font-bold" data-id="element-3067">
                Select Double
              </button>
            </div>
          </div>

          <div className="mt-12 text-center text-sm text-[#2C3E2E]/60 font-light space-x-4" data-id="element-3068">
            <span data-id="element-3069">Limited capacity</span>
            <span data-id="element-3070">•</span>
            <span data-id="element-3071">Curated cohort</span>
            <span data-id="element-3072">•</span>
            <span data-id="element-3073">First-come, invitation-based</span>
          </div>
        </div>
      </section>

      {/* 7. WHO THIS IS FOR */}
      <section className="py-24 px-4 md:px-12 bg-[#F5F2EA]" data-id="element-3074">
        <div className="max-w-3xl mx-auto text-center" data-id="element-3075">
          <h2 className="font-serif text-3xl md:text-4xl text-[#2C3E2E] mb-12" data-id="element-3076">
            Is Soul Flow for you?
          </h2>
          <div className="space-y-6 text-left md:text-center" data-id="element-3077">
            {['You want to reset without disconnecting from luxury', 'You value wellness without extremes', 'You want community without noise', 'You want intention, not performance'].map((item, idx) => <div key={idx} className="flex items-center md:justify-center space-x-4 text-lg md:text-xl font-light text-[#333333]/80" data-id="element-3078">
                <div className="w-6 h-6 rounded-full border border-[#2C3E2E]/30 flex items-center justify-center shrink-0" data-id="element-3079">
                  <CheckIcon className="w-3 h-3 text-[#2C3E2E]" data-id="element-3080" />
                </div>
                <span data-id="element-3081">{item}</span>
              </div>)}
          </div>
        </div>
      </section>

      {/* 8. FINAL CTA & FORM */}
      <section id="registration-form" className="py-24 px-4 md:px-12 bg-[#2C3E2E] text-[#F5F2EA]" data-id="element-3082">
        <div className="max-w-xl mx-auto" data-id="element-3083">
          <div className="text-center mb-12" data-id="element-3084">
            <h2 className="font-serif text-4xl md:text-5xl mb-4" data-id="element-3085">
              Your reset begins here.
            </h2>
            <p className="text-[#F5F2EA]/60 font-light" data-id="element-3086">
              Limited availability · Invitation only
            </p>
          </div>

          <form className="space-y-6 bg-[#F5F2EA]/5 p-8 md:p-12 rounded-sm border border-[#F5F2EA]/10" data-id="element-3087">
            <div className="space-y-2" data-id="element-3088">
              <label htmlFor="name" className="text-xs uppercase tracking-widest opacity-70" data-id="element-3089">
                Full Name
              </label>
              <input type="text" id="name" className="w-full bg-transparent border-b border-[#F5F2EA]/30 py-2 focus:outline-none focus:border-[#F5F2EA] transition-colors placeholder-[#F5F2EA]/20" placeholder="Enter your name" data-id="element-3090" />
            </div>

            <div className="space-y-2" data-id="element-3091">
              <label htmlFor="email" className="text-xs uppercase tracking-widest opacity-70" data-id="element-3092">
                Email Address
              </label>
              <input type="email" id="email" className="w-full bg-transparent border-b border-[#F5F2EA]/30 py-2 focus:outline-none focus:border-[#F5F2EA] transition-colors placeholder-[#F5F2EA]/20" placeholder="Enter your email" data-id="element-3093" />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3094">
              <div className="space-y-2" data-id="element-3095">
                <label htmlFor="date" className="text-xs uppercase tracking-widest opacity-70" data-id="element-3096">
                  Preferred Date
                </label>
                <select id="date" className="w-full bg-transparent border-b border-[#F5F2EA]/30 py-2 focus:outline-none focus:border-[#F5F2EA] transition-colors text-[#F5F2EA] [&>option]:text-[#333333]" data-id="element-3097">
                  <option data-id="element-3098">April 10–13, 2026</option>
                  <option data-id="element-3099">April 17–20, 2026</option>
                  <option data-id="element-3100">April 24–27, 2026</option>
                </select>
              </div>

              <div className="space-y-2" data-id="element-3101">
                <label htmlFor="occupancy" className="text-xs uppercase tracking-widest opacity-70" data-id="element-3102">
                  Occupancy
                </label>
                <select id="occupancy" className="w-full bg-transparent border-b border-[#F5F2EA]/30 py-2 focus:outline-none focus:border-[#F5F2EA] transition-colors text-[#F5F2EA] [&>option]:text-[#333333]" data-id="element-3103">
                  <option data-id="element-3104">Single Occupancy ($2199)</option>
                  <option data-id="element-3105">Double Occupancy ($1599)</option>
                </select>
              </div>
            </div>

            <div className="space-y-2" data-id="element-3106">
              <label htmlFor="notes" className="text-xs uppercase tracking-widest opacity-70" data-id="element-3107">
                Optional Notes
              </label>
              <textarea id="notes" rows={3} className="w-full bg-transparent border-b border-[#F5F2EA]/30 py-2 focus:outline-none focus:border-[#F5F2EA] transition-colors placeholder-[#F5F2EA]/20 resize-none" placeholder="Dietary restrictions, injuries, or intentions..." data-id="element-3108"></textarea>
            </div>

            <button type="button" className="w-full py-4 mt-8 bg-[#F5F2EA] text-[#2C3E2E] font-medium tracking-wide hover:bg-[#E0E0E0] transition-colors duration-300" data-id="element-3109">
              PRE-REGISTER FOR SOUL FLOW
            </button>
          </form>
        </div>
      </section>

      {/* 9. FOOTER (MINIMAL) */}
      <footer className="py-12 bg-[#F5F2EA] text-center border-t border-[#2C3E2E]/5" data-id="element-3110">
        <div className="space-y-4" data-id="element-3111">
          <div className="flex justify-center space-x-8 text-sm text-[#333333]/60 tracking-wide" data-id="element-3112">
            <a href="mailto:experience@destameet.com" className="hover:text-[#2C3E2E] transition-colors" data-id="element-3113">
              experience@destameet.com
            </a>
            <a href="https://instagram.com/destameet" target="_blank" rel="noopener noreferrer" className="hover:text-[#2C3E2E] transition-colors" data-id="element-3114">
              @destameet
            </a>
          </div>
          <p className="text-xs text-[#333333]/40 uppercase tracking-widest" data-id="element-3115">
            Part of DestaMeet
          </p>
        </div>
      </footer>
    </div>;
}